import React, { ReactElement, useState } from "react";

import { contract, Frame, TaskBar, TitleBar, Alert, List } from "@react95/core";

import {
  Confcp102,
  Winpopup3,
  Notepad,
  Computer3,
  FolderExe,
  FolderExe2,
  MicrosoftExchange,
  MsDos,
  MicrosoftNetwork,
  WindowsExplorer,
  LoaderBat,
  Ie,
} from "@react95/icons";

import { useApp } from "../../context/AppContext";

import { QuestWindowDef } from "../Modal/QuestModal";
import { AboutWindowDef } from "../Modal/AboutMe";
import { RegistryEditorDef } from "../Modal/Registry";
import { NetworkStatusDef } from "../Modal/NetworkStatus";
import { ChatClientDef } from "../Modal/ChatClient";
import { RunDialogDef } from "../Modal/RunDialog";
import { InternetClientDef } from "../Modal/InternetClient";

import { HorizDivider, VertDivider, DoubleVertDivider } from "../UI/Dividers";
import { CustomButton } from "../UI/CustomButton";

import DebugTrayIcon from "../Tray/DebugTrayIcon";
import ConnectionIndicator from "../Tray/ConnectionIndicator";
import SoundTrayIcon from "../Tray/SoundTrayIcon";
import MailTrayIcon from "../Tray/MailTrayIcon";

export default function TaskBarComp() {
  const { appEnableDebug, openModal, volume } = useApp();

  const [showAlert, setShowAlert] = useState<false | string>(false);
  const [alertButtonText, setAlertButtonText] = useState<string>("Thanks");

  const handleCloseAlert = () => {
    setShowAlert(false);
  };

  return (
    <>
      <TaskBar
        leftToolbars={
          <>
            <DoubleVertDivider style={{ marginLeft: "2px" }} />
            <Frame style={{ margin: "1px 6px 1px 2px", height: "100%" }}>
              <CustomButton
                // noShadow
                style={{
                  padding: 0,
                  margin: "0px",
                  width: 32,
                  height: "100%",
                  display: "inline-flex",
                  alignItems: "center",
                  justifyContent: "center",
                  marginRight: contract.space[8],
                  border: "none",
                  outline: "none",
                  color: contract.colors.materialText,
                  boxShadow: "none",
                }}
                onClick={() => {
                  openModal(InternetClientDef, {});
                }}
                title="Internet Explorer"
              >
                <div
                  style={{
                    width: 16,
                    height: 16,
                    display: "inline-flex",
                    alignItems: "center",
                    justifyContent: "center",
                    // border: `1px solid ${contract.colors.borderDark}`,
                    backgroundColor: contract.colors.material,
                    boxSizing: "border-box",
                    padding: 0,
                    boxShadow: "none",
                  }}
                >
                  <Ie variant="16x16_8" style={{ width: "16px", height: "16px" }} />
                </div>
              </CustomButton>
            </Frame>
            <DoubleVertDivider />
          </>
        }
        list={
          <List>
            <List.Item icon={<FolderExe2 variant="32x32_4" />}>
              <List width={"200px"}>
                <List.Item
                  icon={AboutWindowDef.icon}
                  onClick={() => {
                    openModal(AboutWindowDef);
                  }}
                >
                  About
                </List.Item>
                <List.Item
                  icon={InternetClientDef.icon}
                  onClick={() => {
                    openModal(InternetClientDef, {});
                  }}
                >
                  Internet Exploder
                </List.Item>
                <List.Item
                  icon={RegistryEditorDef.icon}
                  onClick={() => {
                    openModal(RegistryEditorDef);
                  }}
                >
                  Registry Editor
                </List.Item>
                <List.Item
                  icon={NetworkStatusDef.icon}
                  onClick={() => {
                    openModal(NetworkStatusDef);
                  }}
                >
                  Network Status
                </List.Item>
              </List>
              Programs
            </List.Item>

            <List.Divider />

            <List.Item
              icon={ChatClientDef.icon}
              onClick={() => {
                openModal(ChatClientDef);
              }}
            >
              eMeSeN Messenger
            </List.Item>

            <List.Item
              icon={QuestWindowDef.icon}
              onClick={() => {
                openModal(QuestWindowDef);
              }}
            >
              Quest Log
            </List.Item>

            {/* <List.Divider />
            <List.Item icon={<MsDos variant="32x32_32" />}>
              MS-DOS Prompt
            </List.Item>

            <List.Item icon={<HelpBook variant="32x32_4" />}>Help</List.Item> */}
            <List.Divider />
            <List.Item
              onClick={() => {
                openModal(RunDialogDef);
              }}
              icon={<LoaderBat variant="32x32_4" />}
            >
              Run...
            </List.Item>
            {/* <List.Divider />
            <List.Item icon={<Computer3 variant="32x32_4" />}>
              Shut Down...
            </List.Item> */}

            {/* <List.Divider /> */}
            <List.Item icon={<Computer3 variant="32x32_4" />}>Shut Down...</List.Item>
          </List>
        }
        clockOnClick={() => {
          const timeQuips = [
            "Time is an illusion.",
            "Lunch time is doubly an illusion.",
            "Time flies like an arrow. Fruit flies like a banana.",
            "The past is history, the future is a mystery, but today is a gift.",
            "Time waits for no one, but Clippy does.",
          ];
          const buttonMessages = [
            "Thanks!",
            "Great.",
            "Okay...",
            "Perfect. Actually, that's just what I needed.",
            "Meh",
          ];
          if (!showAlert) {
            setShowAlert(timeQuips[Math.floor(Math.random() * timeQuips.length)]);
            setAlertButtonText(
              buttonMessages[Math.floor(Math.random() * buttonMessages.length)],
            );
          }
        }}
        trayIcons={
          <>
            {appEnableDebug && <DebugTrayIcon />}
            <MailTrayIcon />
            <SoundTrayIcon />
            <ConnectionIndicator />
          </>
        }
      />
      {showAlert && (
        <Alert
          title="Windows Time"
          type={"info"}
          message={showAlert}
          titleBarOptions={<TitleBar.Close key="close" onClick={handleCloseAlert} />}
          hasSound={volume != 0}
          buttons={[
            {
              value: alertButtonText,
              onClick: handleCloseAlert,
            },
          ]}
        />
      )}
    </>
  );
}
